import angular from 'angular';

const watcherDelay = 100; // ms
const minimumTimeBetweenRendering = 50; // ms

// service is used to create a queue of items' render callbacks. Items passed with pushToQueue method would be rendered one by one
// it helps to avoid performance bottleneck while rendering bunch of items in one place
export const skillsRenderService = ($timeout, $interval) => {
    const cbQueue = [];
    let memo = {};

    const initTimeout = (() => {
        let timerIsSet;

        return ((resetTimer) => {
            if (resetTimer) {
                timerIsSet = false;
                return;
            }

            if (timerIsSet) {
                return;
            }
            timerIsSet = true;

            $timeout(() => {
                initWatcher();
            }, watcherDelay);
        });
    })();

    const pushToQueue = (skillsRenderCallback, talentId, forceClean) => {
        if (forceClean) {
            cbQueue.length = 0;
            memo = {};
        }

        // cancel adding to queue if candidate had been processed
        if (memo[talentId]) {
            return;
        }

        // register candidate whose skills had been added to queue
        memo[talentId] = true;
        cbQueue.push(skillsRenderCallback);
        initTimeout();
    };

    const removeFromQueue = (talentId) => {
        delete memo[talentId];
    };

    return {
        pushToQueue,
        removeFromQueue,
    };

    function initWatcher() {
        const maxAttempts = 10;
        let attempt = 0;
        const interval = $interval(processQueue, minimumTimeBetweenRendering);

        function processQueue() {
            if (maxAttempts <= attempt) {
                memo = {};
                initTimeout(true);
                $interval.cancel(interval);
            }
            if (!cbQueue.length) {
                attempt++;
                return;
            }

            cbQueue.shift()();
            if (attempt > 0) {
                attempt = 0;
            }
        }
    }
};

angular
    .module('TALENYA-FE')
    .factory('searchSkillsRenderService', skillsRenderService);
